var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$classes(),style:(_vm.$styles())},_vm._l((_vm.spec.childViews),function(item,index){return _c('li',{key:(index + "_" + (item.view))},[_c('glib-component',{attrs:{"spec":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }